import React from 'react';

import { PaymentMethodsDialog } from 'components/partials/PaymentMethodsDialog';

import { Page } from '../../components/layouts';
import { DispatchProps, StateProps } from '../../weborder/component/Payment';
import * as Routes from '../../weborder/Routes';

type Props = StateProps & DispatchProps & Routes.Routes;

export function PaymentMethods(props: Props): JSX.Element {
  const {
    AppConfig: appConfig,
    Customer: customer,
    params,
    paymentRemoved,
    payments,
  } = props;

  return (
    <Page pageName="payment-methods">
      <PaymentMethodsDialog
        appConfig={appConfig}
        customer={customer}
        handlePaymentRemoved={paymentRemoved}
        params={params}
        payments={payments}
      />
    </Page>
  );
}
